import { RegimeCaisseState, RegimeCaisse } from './types';
import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { getRegimeCaisse, getIsConnecte } from '@/services/api/regimeCaisse/api';
import _ from 'lodash';

const namespaced: boolean = true;

export const state: RegimeCaisseState = {
	regimeCaisse: undefined,
	errorRegimeCaisse: false
};

export const mutations: MutationTree<RegimeCaisseState> = {
	updateRegimeCaisse(state: RegimeCaisseState, regimeCaisse: RegimeCaisse): void {
		state.regimeCaisse = regimeCaisse;
	},
	updateErrorRegimeCaisse(state: RegimeCaisseState, error: boolean): void {
		state.errorRegimeCaisse = error;
	},
	updateIsConnecte(state: RegimeCaisseState, isConnecte: boolean): void {
		if (state.regimeCaisse !== undefined) {
			state.regimeCaisse = {
				...state.regimeCaisse,
				isConnecte
			};
		} else {
			const regimeCaisse = {
				libelleRegime: '',
				acronymeRegime: '',
				libelleCaisse: '',
				codeCentre: '',
				isConnecte
			};
			state.regimeCaisse = regimeCaisse;
		}
	},
	updateErrorIsConnecte(state: RegimeCaisseState, error: boolean): void {
		state.errorRegimeCaisse = error;
	}

};

export const actions: ActionTree<RegimeCaisseState, RootState> = {
	fetchRegimeCaisse(state, { codeRegime, codeCaisse, codeCentre }): Promise<void> {
		return new Promise((resolve, reject) => {
			return getRegimeCaisse(codeRegime, codeCaisse, codeCentre)
				.then((response: any) => {
					const regimeCaisse: RegimeCaisse = _.get(response, 'data.value');
					regimeCaisse.codeCentre = codeCentre;
					state.commit('updateRegimeCaisse', regimeCaisse);

					getIsConnecte(codeRegime, codeCaisse)
						.then((response: any) => {
							const isConnecte: boolean = _.get(response, 'data.value.regimeConnecte');
							state.commit('updateIsConnecte', isConnecte);
							resolve();
						})
						.catch((error: any) => {
							state.commit('updateErrorIsConnecte', true);
							reject();
						});
				})
				.catch((error: any) => {
					state.commit('updateErrorRegimeCaisse', true);
					reject();
				});
		});
	}
};

export const getters: GetterTree<RegimeCaisseState, RootState> = {
	getRegimeCaisse(state) {
		return state.regimeCaisse;
	},
	getErrorRegimeCaisse(state) {
		return state.errorRegimeCaisse;
	}
};

export const regimeCaisse: Module<RegimeCaisseState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
